import _throwOnUpdateScalar from 'rlink-collections/_throwOnUpdateScalar';
import operations from 'rlink-collections/operations';


export default function setAt (obj, path, value, onUpdateScalar = _throwOnUpdateScalar) {
  return this.updateAt(obj, [[path, operations.set, value]], [], onUpdateScalar);
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/setAt.js